export default __webpack_public_path__ + "static/media/gambrel.b3ec801c.png";